<template>
	<div>
		<label
			v-if="upperLabel"
			class="typo-helper-text color-black-45 mb-0"
			data-test-id="upper-label"
		>
			{{ upperLabel }}
		</label>
		<div class="input-group" :class="{ 'is-invalid': isValid === false }">
			<div
				v-if="prependText"
				class="input-group-prepend"
			>
				<div
					class="input-group-text"
					data-test-id="prepend-text"
				>
					{{ prependText }}
				</div>
			</div>
			<Cleave
				:id="id"
				ref="cleave"
				:options="options"
				:value="value"
				:class="`text-${textAlign}`"
				:placeholder="placeholder"
				:disabled="disabled"
				class="form-control form-control-number"
				@input="handleInput"
			/>
			<div
				v-if="appendText"
				class="input-group-append"
			>
				<div
					class="input-group-text"
					data-test-id="append-text"
				>
					{{ appendText }}
				</div>
			</div>
		</div>
		<div
			v-if="invalidFeedback"
			class="invalid-feedback"
		>
			{{ invalidFeedback }}
		</div>
		<label
			v-if="lowerLabel"
			class="typo-helper-text color-black-45 mb-0"
			data-test-id="lower-label"
		>
			{{ lowerLabel }}
		</label>
	</div>
</template>

<script>
import Cleave from 'vue-cleave-component';

export default {
	components: {
		Cleave,
	},
	props: {
		id: {
			type: String,
			default: null,
		},
		upperLabel: {
			type: String,
			default: null,
		},
		lowerLabel: {
			type: String,
			default: null,
		},
		prependText: {
			type: String,
			default: null,
		},
		appendText: {
			type: String,
			default: null,
		},
		placeholder: {
			type: String,
			default: null,
		},
		decimalScale: {
			type: Number,
			default: 0,
		},
		textAlign: {
			type: String,
			default: 'right',
			validator: (val) => ['left', 'center', 'right'].includes(val),
		},
		value: {
			type: [String, Number],
			default: null,
		},
		invalidFeedback: {
			type: String,
			default: null,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			options: {
				numeral: true,
				numeralPositiveOnly: true,
				rawValueTrimPrefix: true,
				numeralDecimalScale: this.decimalScale,
				onValueChanged: (e) => {
					return e;
				},
			},
		};
	},
	methods: {
		handleInput(number) {
			this.$emit('input', number);
		},
	},
};
</script>

<style lang="scss" scoped>
	.input-group {
		&.is-invalid {
			.form-control {
				border: 1px solid $color-alert;

				&:focus {
					box-shadow: none;
				}
			}
		}
	}
</style>
